import { CustomFieldsResponses as CustomFieldsResponsesComponent } from 'features/CustomFieldsResponses';
import { PunchupViewResponses } from 'features/PunchupPages/CustomFieldsResponse';
import { useAppSelector } from 'store/hooks';

const CustomFieldsResponsesPage = (): JSX.Element => {
	const { isPunchup, greenZoneEnabled } = useAppSelector((state) => state.auth);

	if (isPunchup && greenZoneEnabled) return <PunchupViewResponses />;
	return <CustomFieldsResponsesComponent />;
};

export default CustomFieldsResponsesPage;
